module.exports = __webpack_public_path__ + "img/2.2dcd1c34.png";